import { all, call, fork, put, select, take }          from 'redux-saga/effects';
import service                                         from '../../services';
import {
  APICamerasError,
  APICamerasFetch,
  APICamerasSuccess,
  APILayoutsError,
  APILayoutsFetch,
  APILayoutsSuccess,
  APIMapsSuccess,
  APISetGlobalTriggers,
  APISetPrivileges,
  APIWebPagesSuccess
}                                                      from "../API/actions";
import { chooseServiceGenerator, transformCayugaData } from './utils';


import { API_GET_DATA } from '../../constants/API';


function* loadOcularisLayout() {
  try {
    yield put(APILayoutsFetch());
    const token = window.localStorage.getItem('token');
    const layouts = yield call(service.getLayouts, token);
    yield put(APILayoutsSuccess(layouts));
  } catch (err) {
    yield put(APILayoutsError());
  }
}

function* loadOcularisCameras() {
  try {
    yield put(APICamerasFetch());
    const token = window.localStorage.getItem('token');
    const {cameras, global_triggers} = yield call(service.getCameraList, token);
    yield put(APICamerasSuccess(cameras));
    yield put(APISetGlobalTriggers(global_triggers));
  } catch (err) {
    yield put(APICamerasError());
  }
}

function* loadOcularisPrivilleges() {
  try {
    const token = window.localStorage.getItem('token');
    const data = yield call(service.getPrivilledges, token);
    const parsedData = Object.entries(data).reduce((acc, el) => {
      acc[el[0]] = JSON.parse(el[1]);
      return acc;
    }, {});
    yield put(APISetPrivileges(parsedData));
  } catch (err) {
    console.log(err);
  }
}

function* loadCayugaInfo() {
  yield call(loadCayugaLayout);
  yield call(loadCayugaCameras);
}

function* loadCayugaLayout() {
  try {
    yield put(APILayoutsFetch());
    const token = window.localStorage.getItem('token');
    const layouts = yield call(service.getLayouts, token);

    if (layouts.error) {
      throw layouts.data;
    }
    const res = layouts.data['a:GeneralEntityInfo'] ? layouts.data['a:GeneralEntityInfo'] : [];
    yield put(APILayoutsSuccess(res));
  } catch (err) {
    console.log(err);
    yield put(APILayoutsError());
  }
}

function getEntityList(layouts, entity) {
  const res = [];
  const getData = (data) => {
    const entityInfo = data?.['a:SubEntities']?.['a:GeneralEntityInfo'];
    if (Array.isArray(entityInfo)) {
      entityInfo.forEach(el => {
        if (el['a:EntityType'] === entity) {
          res.push(el);
        } else if (el['a:EntityType'] === 'PathBranch' | el['a:EntityType'] === 'PathFolder') {
          getData(el);
        }
      });
    } else {
      if (entityInfo['a:EntityType'] === entity) {
        res.push(entityInfo);
      } else if (entityInfo['a:EntityType'] === 'PathBranch' | entityInfo['a:EntityType'] === 'PathFolder') {
        getData(entityInfo);
      }
    }
  };
  getData(layouts);
  return res;
}

function* loadCayugaCameras() {
  try {
    yield put(APICamerasFetch());
    const token = window.localStorage.getItem('token');
    const res = yield call(service.getDetailedCameraList, token);
    if (res.error) {
      throw res.error;
    }
    const transformedData = transformCayugaData(res.data['a:CameraEntityInfo']);
    const {layouts} = yield select(state => state.API);
    const maps = transformCayugaData(getEntityList(layouts, 'Map'));
    const webPages = transformCayugaData(getEntityList(layouts, 'WebPage'));

    yield put(APICamerasSuccess(!res.error ? Array.isArray(transformedData) ? [...transformedData] : [transformedData] : []));
    yield put(APIMapsSuccess(maps));
    yield put(APIWebPagesSuccess(webPages));

    const buttons = yield call(service.requestButtonList, token);
    if (buttons.error) {
      throw buttons.error;
    }

    yield put(APISetGlobalTriggers(buttons.data['a:ButtonEntityInfo'] ? buttons.data['a:ButtonEntityInfo'] : []));
  } catch (err) {
    console.log(err)
    yield put(APICamerasError());
  }
}

function* loadTasks(tasks, service) {
  yield all(tasks.map(task => task && fork(task, service)));
}

function* loadData() {
  yield take(API_GET_DATA);

  yield call(chooseServiceGenerator,
    {fn: loadTasks, args: [[loadOcularisLayout, loadOcularisCameras, loadOcularisPrivilleges]]},
    {fn: loadTasks, args: [[loadCayugaInfo]]}
  );
}

export default loadData;